import type { RouteObject } from 'react-router';
import { ModuleRoute } from '@/components/guards';

/** Rotas deste módulo, montadas dentro do layout do painel (caminhos relativos). */
export const storefrontRoutes: RouteObject[] = [
  {
    path: 'loja',
    element: <ModuleRoute module="storefront" permission="storefront:read" />,
    children: [
      {
        lazy: async () => ({ Component: (await import('./layout')).StorefrontLayout }),
        children: [
          { index: true, lazy: async () => ({ Component: (await import('./editor')).StoreEditorPage }) },
          { path: 'paginas', lazy: async () => ({ Component: (await import('./pages')).StorePagesPage }) },
          { path: 'banners', lazy: async () => ({ Component: (await import('./banners')).BannersPage }) },
          { path: 'dominios', lazy: async () => ({ Component: (await import('./domains')).DomainsPage }) },
        ],
      },
    ],
  },
];
